










































import { Vue, Component } from "vue-property-decorator"
import references from "@/data/references"

@Component
export default class References extends Vue {
  public onSwipeRight() {
    this.$router.push("/enneagram")
  }

  // getters needed to make imported data available to template

  // noinspection JSMethodCanBeStatic
  get references() {
    return references
  }
}
